import CalendarPicker from '@mui/lab/CalendarPicker';
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import ButtonCancel from "components/Buttons/ButtonCancel";
import ButtonOk from "components/Buttons/ButtonOk";
import moment, { Moment } from "moment";
import * as React from "react";

interface IState {
    customStartDate: Date;
    customEndDate: Date;
}

interface IProps {
    startDate?: Date;
    endDate?: Date;
    onSelect: (result: { start: Date, end: Date; }) => void;
}

class DateRangePickerDialog extends React.PureComponent<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        if (props.startDate < props.endDate) {
            this.state = {
                customStartDate: moment(props.startDate).startOf('day').toDate(),
                customEndDate: moment(props.endDate).endOf('day').toDate()
            };
        }
        else {
            const date = moment();
            this.state = {
                customStartDate: date.startOf('day').toDate(),
                customEndDate: date.endOf('day').toDate()
            };
        }
    }

    render() {
        const { customStartDate, customEndDate } = this.state;

        return (
            <Dialog
                open
                fullWidth
                maxWidth="md"
                role="dialog"
                onBackdropClick={() => { this.props.onSelect(null); }}
                onClose={() => { this.props.onSelect(null); }}
            >
                <DialogContent style={{ margin: 0, padding: 0 }}>
                    <Grid container justifyContent="space-around" alignItems="center">
                        <Grid item>
                            <CalendarPicker<Moment>
                                maxDate={moment(customEndDate)}
                                date={moment(customStartDate)}
                                onChange={
                                    (dt: Moment) => {
                                        this.setState((state) => {
                                            const newState = { ...state };
                                            newState.customStartDate = dt.startOf('day').toDate();
                                            if (newState.customEndDate == null) newState.customEndDate = newState.customStartDate;
                                            return { ...newState };
                                        });
                                    }
                                }
                            />
                        </Grid>
                        <Grid item>
                            <CalendarPicker<Moment>
                                minDate={moment(customStartDate)}
                                date={moment(customEndDate)}
                                onChange={
                                    (dt: Moment) => {
                                        this.setState((state) => {
                                            const newState = { ...state };
                                            newState.customEndDate = dt.endOf('day').toDate();
                                            if (newState.customStartDate == null) newState.customStartDate = newState.customEndDate;
                                            return { ...newState };
                                        });
                                    }
                                }
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>

                    <ButtonCancel
                        onClick={() => this.props.onSelect(null)}
                    />

                    <ButtonOk
                        color="secondary"
                        onClick={() => this.props.onSelect({ start: customStartDate, end: customEndDate })}
                    />

                </DialogActions>
            </Dialog>
        );
    }
}

export default DateRangePickerDialog;
